import { MODE as MODES, PLAY_STATUS } from '@src/games/constant'

export const PLAYS = {
  NAME: 'play',
  NAMESPACE: (name) => `play/${name}`,
  CLEAR: 'CLEAR',
  SET_PLAY: 'SET_PLAY',
  GET_PLAY: 'GET_PLAY',
  GET_PLAY_MODE: 'GET_PLAY_MODE',
  GET_PLAY_CONFIG: 'GET_PLAY_CONFIG',
  SET_PLAY_STATUS: 'SET_PLAY_STATUS',
  GET_PLAY_STATUS: 'GET_PLAY_STATUS',
  SET_START_TIME: 'SET_START_TIME',
  GET_START_TIME: 'GET_START_TIME',

  GET_ANSWER_POSITION: 'GET_ANSWER_POSITION',
  SET_ACTIVE_SCENE_ID: 'SET_ACTIVE_SCENE_ID',
  GET_ACTIVE_SCENE_ID: 'GET_ACTIVE_SCENE_ID',
  SET_ACTIVE_SCENE_INDEX: 'SET_ACTIVE_SCENE_INDEX',
  GET_ACTIVE_SCENE_INDEX: 'GET_ACTIVE_SCENE_INDEX',
  SET_PLAY_PERCENT: 'SET_PLAY_PERCENT',
  GET_PLAY_SELECTS: 'GET_PLAY_SELECTS',
  GET_PERCENT: 'GET_PERCENT',

  ADD_USER_SELECT: 'ADD_USER_SELECT',
  ADD_ANSWER_POSITION: 'ADD_ANSWER_POSITION',
}

export const state = {
  status: PLAY_STATUS.READY,
  mode: MODES.BEGINNER,
  id: null,
  name: null,
  config: null,
  theme: null,
  descriptions: [],
  answerElements: [],
  sceneIndex: 0,
  sceneId: null,
  selects: {},
  percent: 0,
  startTime: null,
}

export const mutations = {
  [PLAYS.CLEAR](state) {
    state.mode = null
    state.id = null
    state.name = null
    state.config = null
    state.theme = null
    state.descriptions = []
    state.answerElements = []
    state.sceneIndex = 0
    state.sceneId = null
    state.selects = {}
    state.percent = 0
    state.startTime = null
  },
  [PLAYS.SET_PLAY](state, { mode, id, name, theme, config, descriptions }) {
    state.mode = mode
    state.id = id
    state.name = name
    state.config = config
    state.theme = theme
    state.descriptions = descriptions
  },
  [PLAYS.SET_PLAY_STATUS](state, status) {
    state.status = status
  },
  [PLAYS.SET_ACTIVE_SCENE_INDEX](state, index) {
    state.sceneIndex = index
  },
  [PLAYS.SET_ACTIVE_SCENE_ID](state, id) {
    state.sceneId = id
  },
  [PLAYS.ADD_USER_SELECT](state, { id, value }) {
    state.selects[id] = value || null
  },
  [PLAYS.SET_PLAY_PERCENT](state, percent) {
    state.percent = percent
  },
  [PLAYS.ADD_ANSWER_POSITION](state, { id, position }) {
    state.answerElements.push({ id, position })
  },
  [PLAYS.SET_START_TIME](state, time) {
    state.startTime = time
  },
}

export const getters = {
  [PLAYS.GET_PLAY](state) {
    return {
      mode: state.mode,
      id: state.id,
      name: state.name,
      config: state.config,
      theme: state.theme,
      descriptions: state.descriptions,
    }
  },
  [PLAYS.GET_PLAY_STATUS](state) {
    return state.status
  },
  [PLAYS.GET_PLAY_MODE](state) {
    return state.mode
  },
  [PLAYS.GET_PLAY_CONFIG](state) {
    return state.config
  },
  [PLAYS.GET_ACTIVE_SCENE_INDEX](state) {
    return state.sceneIndex
  },
  [PLAYS.GET_ACTIVE_SCENE_ID](state) {
    return state.sceneId
  },
  [PLAYS.GET_PLAY_SELECTS](state) {
    return state.selects
  },
  [PLAYS.GET_PERCENT](state) {
    return state.percent
  },
  [PLAYS.GET_ANSWER_POSITION](state) {
    return state.answerElements
  },
  [PLAYS.GET_START_TIME](state) {
    return state.startTime
  },
}

export const actions = {
  [PLAYS.CLEAR]({ commit }) {
    commit(PLAYS.CLEAR)
  },
  [PLAYS.ADD_ANSWER_POSITION]({ commit, dispatch, getters }, { id, position }) {
    if (!id || !position) {
      throw new Error('not found answer element position! check it please~')
    }

    commit(PLAYS.ADD_ANSWER_POSITION, { id, position })
  },
}
